const requestConfig={
    headers:{
        'Content-Type':'application/json'
    },
    body:{
        'header_systemId':"01",
        'header_bankNo':"105",
        'header_date':"",
        'header_branchNo':"",
        'header_uuid':"",
        'header_timeStamp':"",
        'header_tellerNo':"",
        'header_jrnlNo':"",
    },
    timeout:60000
}
export default requestConfig;



//////////////////
// WEBPACK FOOTER
// ./static/http/requestConfig.js
// module id = null
// module chunks = 